import { Text, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';

import './promotedContent.module.scss';
import { PromotedContentFields } from './MegaNavigation.types';

type PromotedContentProps = {
  fields: PromotedContentFields;
  className: string;
  isWide: boolean;
  e2eId: string;
  closeMegaNavBody: () => void;
};

const PromotedContent = ({
  fields,
  isWide = false,
  e2eId = '',
  className = '',
  closeMegaNavBody,
}: PromotedContentProps) => {
  const hasRequiredFields = fields?.title?.value && fields?.ctaLink?.value?.href;

  if (!hasRequiredFields) {
    return null;
  }

  return (
    <div
      data-e2e-component-uid={e2eId}
      className={`promoted-content ${className} ${isWide ? 'promoted-content--wide' : ''}`}
    >
      <div className="p-2 promoted-content-wrapper background-primary">
        <Text className="background-to-change" tag="h6" field={fields.title} />
        <NextImage
          field={fields.image}
          className="promoted-content__image mt-2"
          width={238}
          height={133}
        />
        <Text className="body-small mt-2 background-to-change" tag="p" field={fields.description} />
        <ScLink
          field={fields.ctaLink}
          onClick={closeMegaNavBody}
          replaceWithSlot
          showExternalIcon
          className="text-link revert-underline mt-2 d-inline-block background-to-change"
        />
      </div>
    </div>
  );
};

export default PromotedContent;
